import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "SaleChartComponent",
    datasets: [],
    labels: "months",
    loading: true,
    style:"height: 150px",
    options: ChartOptions.getSaleChartOptions(),
    config: {
        datasets: {
            today: {
                borderColor: "#a1704b",
            },
            yesterday: {
                borderColor: "#d2a17d",
            }
        }

    }
}